import { normalizedStartCase } from "helpers/normalizedStartCase"

export const columns = [
  {
    title: "Tree Comment Id",
    value: "id",
  },
  {
    title: "User Name",
    value: (row) => row?.user?.username || "N/A",
  },
  {
    title: "User Id",
    value: "userId",
  },
  {
    title: "Comment",
    value: "message",
  },
  {
    title: "Upvotes",
    value: "upvotes",
  },
  {
    title: "Display Status",
    value: (row) => normalizedStartCase(row?.hidden ? "HIDDEN" : "PUBLISHED"),
  },
  {
    title: "Creation Date",
    value: "createdAt",
    format: "date",
  },
  {
    title: "Last Updated on",
    value: "updatedAt",
    format: "date",
  },
]
